import React, { MouseEvent } from 'react'

import { IconButton } from 'components'
import { copyTextToClipboard } from 'utils/clipboard'
import { colors } from 'utils/colors'

type Props = {
  clipBoardContent?: any
  onClipBoardCopied?: (clipBoardContent: any) => void
  icon?: string[] | string
  iconColor?: keyof typeof colors
  size?: number
}

const CopyToClipBoardButton: React.FC<Props> = ({ clipBoardContent, onClipBoardCopied, iconColor, icon, size }) => (
  <IconButton
    icon={icon || ['far', 'copy']}
    iconSize={size || 16}
    iconColor={iconColor || 'gray5'}
    variant="ghost"
    onClick={(e: MouseEvent) => {
      e.stopPropagation()
      copyTextToClipboard(clipBoardContent)
      onClipBoardCopied?.(clipBoardContent)
    }}
  />
)

export default CopyToClipBoardButton
